import faqsAnswersTranslations from 'i2l?query=sporks!pricing-pages-ui/lang/faqsAnswers/en.lyaml';
import { FrequentlyAskedQuestionsContainer } from 'pricing-pages-ui-components/frequentlyAskedQuestions/FrequentlyAskedQuestions';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { Children, cloneElement, createContext, isValidElement, useState } from 'react';
import { useTranslations } from '../../hooks/useTranslations';
import { defaultTranslationsStatus } from '../../interfaces/TranslationsContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const TranslationsContext = /*#__PURE__*/createContext(defaultTranslationsStatus);
const Faq = ({
  children
}) => {
  const [shouldLoadTranslations, setShouldLoadTranslations] = useState(false);
  const {
    isReady
  } = useTranslations(faqsAnswersTranslations, shouldLoadTranslations);
  const handleLoadTranslations = () => {
    if (!shouldLoadTranslations) {
      setShouldLoadTranslations(true);
    }
  };
  const childrenWithProps = Children.map(children, child => {
    if ( /*#__PURE__*/isValidElement(child)) {
      return /*#__PURE__*/cloneElement( /* Replace with QuestionProps once Question.js is typed */
      child, {
        onQuestionClick: handleLoadTranslations
      });
    }
    return child;
  });
  return /*#__PURE__*/_jsx(PageSection, {
    "data-selenium-id": "faq-container",
    children: /*#__PURE__*/_jsx(TranslationsContext.Provider, {
      value: {
        isReady
      },
      children: /*#__PURE__*/_jsx(FrequentlyAskedQuestionsContainer, {
        children: childrenWithProps
      })
    })
  });
};
export default Faq;